import React, {Component} from "react";
import LinksContainer from "../../components/linkelement/LinksContainer";
import LinkCard from "../../components/linkelement/LinkCard";

class GemLinksAusschuss extends Component {

  render() {

    return <LinksContainer mainTagTitle='Glieder' title='Freikirche der Siebenten-Tags-Adventisten Gemeinde Langau i.E.' width='105px' subtitle='Zugang zur DSV-Cloud — Wähle eine Kachel.'>
      <LinkCard link='https://cloud.adventisten.ch/s/FJFpfckiZcDdqpL' numOfColumns='1' title='Glieder' subtitle='Bereich Glieder' description='Hier findest du den Bereich für die Gemeinde-Glieder.' />
      <LinkCard link='https://cloud.adventisten.ch/s/xKETMmy457A263R' numOfColumns='1' title='Glieder' subtitle='Bereich Gäste' description='Hier findest du den Bereich für die Gäste.' />
      <LinkCard link='https://cloud.adventisten.ch/s/oenMWEq9Dc2Pw7k' numOfColumns='1' title='Temporär' subtitle='Temporärer Platz' description='Hier kannst du Temporär Daten hochladen und downloaden.' />
    </LinksContainer>;
  }
}

export default GemLinksAusschuss;
